import http from './http';

export function fetchAnnouncements() {
  return http.get('/announcements');
}

export function fetchLatestAnnouncement() {
  return http.get('/announcements/latest');
}

export function markAnnouncementRead(id) {
  return http.put(`/announcements/${id}/read`);
}
